import {
  boughtTogether,
  KlevuFetch,
  KlevuTypeOfRecord,
  KlevuTypeOfRequest,
  personalisation,
  raw,
  sendRecommendationViewEvent,
  similarProducts,
  KMCRecommendationLogic,
  KlevuEvents,
  fallback,
  alsoViewed,
  recentlyViewed,
  boostWithKeywords,
  products,
  boostWithFilters,
  trendingCategoryProducts,
  visuallySimilar,
  newArrivals,
} from "@klevu/core";
import { getKlevuId } from "../klevu";

const recsTitles = {
  trendingProducts: "Trending Products",
  trendingProductsForYou: "Trending Products For You",
  newarrivals: "New Arrivals",
  similar: "Similar Products",
  boughtTogether: "Customers Also Bought",
  alsoviewed: "Customers Also Viewed",
  recentlyViewedProducts: "Recently Viewed",
};

const recsLogic = {
  trendingProducts: KMCRecommendationLogic.Trending,
  newarrivals: KMCRecommendationLogic.NewestArrivals,
  similar: KMCRecommendationLogic.Similar,
  boughtTogether: KMCRecommendationLogic.BoughtTogether,
  alsoviewed: KMCRecommendationLogic.OtherAlsoViewed,
};

const querySettings = {
  typeOfRecords: [KlevuTypeOfRecord.Product],
  groupCondition: {
    groupOperator: "ALL_OF",
    conditions: [
      {
        key: "outfit",
        singleSelect: true,
        valueOperator: "EXCLUDE",
        values: ["true"],
      },
    ],
  },
};

export default () => ({
  cssClasses: [],
  klevuProds: [],
  query: null,
  queryFunc: null,
  queryVariantIds: [],
  recsKey: "",
  recsID: "",
  recsLogic: "",
  recsTitle: "",
  interests: [],
  prodGender: "",
  prodId: "",
  listId: "",
  segmentName: "",
  items: {},


  viewPromotion(heading) {
    Tracking.viewPromotion("Product Slider Klevu", heading);
  },

  selectPromotion(heading) {
    Tracking.selectPromotion("Product Slider Klevu", heading);
  },

  async search(setClasses) {
    try {
      const result = await KlevuFetch(this.queryFunc);
      const queryResults = result.apiResponse.queryResults;
      const queryResult = queryResults.find((result) => result.records?.length);

      if (queryResult) {
        this.klevuProds = queryResult.records;
        const recsKey = queryResult.id;
        const recsMetaKey = recsKey ? recsKey.replace("-fallback", "") : "";

        if (recsKey && recsTitles[recsMetaKey] && recsLogic[recsMetaKey]) {
          this.recsKey = recsKey;
          this.recsTitle = recsTitles[recsMetaKey];
          this.recsLogic = recsLogic[recsMetaKey];
        }
      }

      if (setClasses) {
        this.setWrapperClasses();
      }
    } catch (error) {
      console.log(error);
    }
  },

  getInterests(interest) {
    const arr = interest.split(",");
    arr.map((interest) => {
      let obj = {
        phrase: `${interest}`,
        weight: Math.floor(Math.random() * 989) + 10,
      };
      this.interests.push(obj);
    });
  },

  getProductId(id) {
    this.prodId = `v${id}`;
  },

  setWrapperClasses() {
    this.klevuProds.forEach((item, index) => {
      let i = index + 1;
      let remainder = i % 3;
      let desktopColumnClass = "col-span-9 lg:col-span-6 ";
      let firstPadding = "";
      let lastPadding = "";

      if (i === 1) {
        firstPadding = "pl-8 lg:pl-12";
      } else if (i == this.klevuProds.length) {
        lastPadding = "pl-0 pr-8 lg:pr-12";
      }

      this.cssClasses.push(
        `${desktopColumnClass}`
      );
    });
  },

  async setKlevuQuery(query, boostKeyword, boostInterests, pageType) {
    const section = query;
    let boostKeywordVal = [];

    if (boostKeyword) {
      if (boostInterests && this.interests.length > 0) {
        let obj = {
          phrase: boostKeyword,
          weight: Math.floor(Math.random() * 989) + 10,
        };
        this.interests.push(obj);
      } else {
        let obj = {
          phrase: boostKeyword,
          weight: Math.floor(Math.random() * 989) + 10,
        };
        boostKeywordVal.push(obj);
      }
    }

    let keyword;

    if (boostInterests && this.interests.length > 0) {
      //Boost Interests and Keyword
      keyword = this.interests;
    } else {
      //Boost Keyword or nothing
      keyword = boostKeywordVal;
    }

    switch (section) {
      case "trending_products":
        this.queryFunc = raw(
          {
            id: "trendingProducts",
            typeOfRequest: KlevuTypeOfRequest.Trending,
            settings: {
              typeOfRecords: [KlevuTypeOfRecord.Product],
            },
          },
          personalisation(),
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(recsTitles["trendingProducts"], {})
        );
        break;
      case "trending_products_category":
        const categoryPath = window.shopCollection.name;
        this.queryFunc = trendingCategoryProducts(
          categoryPath,
          {},
          boostWithKeywords(keyword),
          personalisation()
        );
        break;
      case "trending_products_personalized":
        this.queryFunc = raw(
          {
            id: "trendingProductsForYou",
            typeOfRequest: KlevuTypeOfRequest.Trending,
            settings: {
              typeOfRecords: [KlevuTypeOfRecord.Product],
            },
          },
          personalisation(),
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(
            recsTitles["trendingProductsForYou"],
            {}
          )
        );
        break;
      case "new_arrivals":
        this.queryFunc = raw(
          {
            id: "newarrivals",
            typeOfRequest: KlevuTypeOfRequest.NewArrivals,
            settings: querySettings,
          },
          personalisation(),
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(recsTitles["newarrivals"], {})
        );
        break;
      case "new_arrivals_category":
        const categoryName = window.shopCollection.name;
        this.queryFunc = newArrivals(
          categoryName,
          {},
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(recsTitles["newarrivals"], {})
        );
        break;
      case "similar_products":
        const result = await KlevuFetch(products([this.prodId]));
        const queryResults = result.apiResponse.queryResults;
        const queryResult = queryResults.find(
          (result) => result.records?.length
        );

        if (queryResult) {
          this.prodGender = queryResult.records[0]?.category
            .split(";;")
            .includes("Men")
            ? "Men"
            : "Women";
        }

        this.queryFunc = similarProducts(
          this.queryVariantIds,
          {},
          boostWithFilters([
            {
              key: "category",
              values: [this.prodGender],
              weight: 999,
            },
          ]),
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(recsTitles["similar"], {})
        );
        break;
      case "visually_similar":
        const productId = `p${window.shopifyProduct.product.id}`;
        this.queryFunc = visuallySimilar([productId]);
        break;
      case "recently_viewed":
        this.queryFunc = recentlyViewed(
          { id: "recentlyViewedProducts" },
          personalisation(),
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(recsTitles["recentlyViewedProducts"], {})
        );
        break;
      case "customers_also_viewed":
        this.queryFunc = alsoViewed(
          {},
          personalisation(),
          boostWithKeywords(keyword),
          sendRecommendationViewEvent(recsTitles["alsoViewed"], {})
        );
        break;
      case "customers_also_viewed_pdp":
        this.queryFunc = raw({
          id: "recsAlsoViewed",
          typeOfRequest: KlevuTypeOfRequest.AlsoViewed,
          settings: {
            context: {
              recentObjects: [
                {
                  typeOfRecord: "KLEVU_PRODUCT",
                  records: [
                    {
                      id: `v${window.shopifyProduct.product.variants[0].id}`,
                    },
                  ],
                },
              ],
            },
            typeOfRecords: ["KLEVU_PRODUCT"],
          },
          boostWithKeywords: keyword,
        });
        break;
      case "customers_also_bought":
        const url = `${location.origin}/cart.js`;
        let items = [];
        try {
          const cartRes = await fetch(url);
          if (cartRes.ok) {
            const cart = await cartRes.json();
            items = cart.items;
          }
        } catch (error) {
          console.log(error);
        }

        if (Array.isArray(items)) {
          this.queryVariantIds = items.map((item) => `v${item.variant_id}`);
          this.queryFunc = boughtTogether(
            this.queryVariantIds,
            {},
            fallback(
              raw(
                {
                  id: "trending_products",
                  typeOfRequest: KlevuTypeOfRequest.Trending,
                  settings: querySettings,
                },
                personalisation(),
                sendRecommendationViewEvent(recsTitles["trendingProducts"], {})
              )
            ),
            personalisation(),
            boostWithKeywords(keyword),
            sendRecommendationViewEvent(recsTitles["boughtTogether"], {})
          );
        }
        break;
      case "customers_also_bought_pdp":
        this.queryFunc = raw({
          id: "recsAlsoBoughtPdp",
          typeOfRequest: KlevuTypeOfRequest.AlsoBought,
          settings: {
            context: {
              recentObjects: [
                {
                  typeOfRecord: "KLEVU_PRODUCT",
                  records: [
                    {
                      id: `v${window.shopifyProduct.product.variants[0].id}`,
                    },
                  ],
                },
              ],
            },
            typeOfRecords: ["KLEVU_PRODUCT"],
          },
          boostWithKeywords: keyword,
        });
        break;
      case "hand_picked":
        let topIdsArr = [];

        this.queryVariantIds.map((item) => {
          let obj = {
            key: "id",
            value: `${item}`,
          };

          topIdsArr.push(obj);
        });

        this.queryFunc = raw({
          id: "ourRecommendedProducts",
          typeOfRequest: KlevuTypeOfRequest.Search,
          settings: {
            customANDQuery: `id:(${this.queryVariantIds.join(" OR ")})`,
            topIds: topIdsArr,
            typeOfRecords: [KlevuTypeOfRecord.Product],
          },
        });
        break;
      default:
        this.queryFunc = raw(
          {
            id: "newarrivals",
            typeOfRequest: KlevuTypeOfRequest.NewArrivals,
            settings: querySettings,
          },
          personalisation(),
          sendRecommendationViewEvent(recsTitles["newarrivals"], {})
        );
        break;
    }
    this.search(true);
  },
  setProducts(variantId) {
    this.queryVariantIds.push(`v${variantId}`);
  },

  dispatchFavoritesEvent() {
    const event = new CustomEvent("shopify-wishlist:KlevuLoaded", {});
    document.dispatchEvent(event);
  },

  handleRecomendationsClick(event) {
    const id = event.currentTarget.getAttribute("data-id");
    const index = this.klevuProds.findIndex((r) => r.id === id);
    const product = this.klevuProds.find((r) => r.id === id);
    const itemId = event.currentTarget.getAttribute("data-id");
    const itemGroupId = event.currentTarget.getAttribute("data-groupId");
    const itemName = event.currentTarget.getAttribute("data-name");
    const price = event.currentTarget.getAttribute("data-price");
    const logic = this.recsLogic
    const recsKey = this.recsKey
    const recsTitle = this.recsTitle

    var klevuId = getKlevuId();
    if (!klevuId) {
      throw new Error("No Klevu ID available");
    }
  

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    const raw = JSON.stringify([
      {
        event: "select_recs_list",
        event_apikey: klevuId,
        event_list_id: recsKey, 
        event_list_name: recsTitle,
        event_list_logic: logic,
        items: [{
          item_id: itemId,
          item_group_id: itemGroupId,
          item_variant_id: itemId,
          item_name: itemName,
          price: price
        }],
        index: index

      },
    ]);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };


    const url = "https://stats.ksearchnet.com/analytics/collect";

    fetch(url, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
  },
});
